export const BasicData =[
    {
        id:1,
        title:'Rock'
    },
    {
        id:2,
        title:'Paper'
    },
    {
        id:3,
        title:'Scissor'
    },
]



export const AdvanceData =[
    {
        id:1,
        title:'Rock'
    },
    {
        id:2,
        title:'Paper'
    },
    {
        id:3,
        title:'Scissor'
    },
    {
        id:4,
        title:'Lizard'
    },
    {
        id:5,
        title:'Spock'
    },
]